import { useEffect, useRef, useState } from "react";
export const useCountDownTimer = ({
  onTimeEnd,
  differenceFrom,
  stopTimer,
  expandTimeOnEndReach = 0,
  resetOnEnd
}: {
  onTimeEnd?: () => void;
  differenceFrom?: EpochTimeStamp;
  stopTimer?: boolean;
  expandTimeOnEndReach?: number;
  resetOnEnd?: boolean;
}) => {
  const [now, setNow] = useState(Date.now());
  const interval = useRef<ReturnType<typeof setInterval> | undefined>(undefined);
  const endedReference = useRef(false);
  const targetTimeReference = useRef<number>(differenceFrom ?? new Date().setHours(24, 0, 0, 0));
  const calcNumber = (n: number) => String(n).padStart(2, "0");
  const deltaTime = (() => {
    const diff = (targetTimeReference.current - now) / 1000;
    if (diff <= 0 && resetOnEnd) {
      targetTimeReference.current += expandTimeOnEndReach * 1000;
      endedReference.current = false;
      return (targetTimeReference.current - now) / 1000;
    }
    return diff;
  })();
  useEffect(() => {
    if (deltaTime <= 0 && !endedReference.current) {
      endedReference.current = true;
      if (!resetOnEnd) {
        clearInterval(interval.current);
        interval.current = undefined;
        onTimeEnd?.();
      }
    }
  }, [deltaTime, onTimeEnd, resetOnEnd]);
  useEffect(() => {
    if (stopTimer) return;
    interval.current = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => {
      clearInterval(interval.current);
    };
  }, [stopTimer]);
  return {
    timeLeft: deltaTime > 0 ? {
      hours: calcNumber(Math.floor(deltaTime / 3600 % 24)),
      minutes: calcNumber(Math.floor(deltaTime / 60 % 60)),
      seconds: calcNumber(Math.floor(deltaTime % 60)),
      originalTime: deltaTime
    } : null
  };
};